import { useEffect, lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import LoginPage from '@/pages/Login';
import { useAuth } from '@/store/auth';
import { Loader2 } from 'lucide-react';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const NovaRota = lazy(() => import('@/pages/NovaRota'));
const Triagem = lazy(() => import('@/pages/Triagem'));
const Historico = lazy(() => import('@/pages/Historico'));
const Frota = lazy(() => import('@/pages/Frota'));
const Custeio = lazy(() => import('@/pages/Custeio'));
const Atribuicoes = lazy(() => import('@/pages/Atribuicoes'));
const Cadastros = lazy(() => import('@/pages/Cadastros'));
const Configuracoes = lazy(() => import('@/pages/Configuracoes'));

function PageLoader() {
  return (
    <div className="h-full w-full grid place-items-center text-ink-400">
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  const { initialize, loading } = useAuth();
  useEffect(() => {
    void initialize();
  }, [initialize]);

  if (loading) return <PageLoader />;

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route
          path="/"
          element={
            <Suspense fallback={<PageLoader />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path="/nova-rota"
          element={
            <Suspense fallback={<PageLoader />}>
              <NovaRota />
            </Suspense>
          }
        />
        <Route
          path="/triagem/:id"
          element={
            <Suspense fallback={<PageLoader />}>
              <Triagem />
            </Suspense>
          }
        />
        <Route
          path="/historico"
          element={
            <Suspense fallback={<PageLoader />}>
              <Historico />
            </Suspense>
          }
        />
        <Route
          path="/frota"
          element={
            <Suspense fallback={<PageLoader />}>
              <Frota />
            </Suspense>
          }
        />
        <Route
          path="/custeio"
          element={
            <Suspense fallback={<PageLoader />}>
              <Custeio />
            </Suspense>
          }
        />
        <Route
          path="/atribuicoes"
          element={
            <Suspense fallback={<PageLoader />}>
              <Atribuicoes />
            </Suspense>
          }
        />
        <Route
          path="/cadastros"
          element={
            <Suspense fallback={<PageLoader />}>
              <Cadastros />
            </Suspense>
          }
        />
        <Route
          path="/configuracoes"
          element={
            <Suspense fallback={<PageLoader />}>
              <Configuracoes />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
